<template>
  <div class="author-wrapper p-5">
    <el-form label-position="top" label-width="80px" v-if="form_list">
      <div  v-for="item in form_list" :key="item.index" v-if="item.hidden !== 1">
        <div v-if="item.type == 'text'">
          <el-form-item :label="item.title" :required="item.required == 1">
            <el-input v-model="item.value"></el-input>
          </el-form-item>
        </div>
         <div v-if="item.type == 'checkbox'" class="checkbox">
          <el-form-item :label="item.title" :required="item.required == 1">
            <el-checkbox-group v-model="item.value" :max="3">
              <div v-for="opt in item.options" :key="opt.index" class="">
                <el-checkbox :label="opt.value" ></el-checkbox>
                <div class=" w-100" v-if="opt.value == '其他' && item.value.indexOf(opt.value) !== -1">
                  <el-input v-model="opt.children[0].value"></el-input>
                </div>
              </div>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div v-if="item.type == 'radio'">
          <el-form-item :label="item.title" :required="item.required == 1">
            <el-radio-group v-model="item.value">
              <div v-for="opt in item.options" :key="opt.index" class="mb-3">
                <el-radio :label="opt.value">{{opt.value}}</el-radio>
              </div>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <el-form-item class=" w-100 mt-5 m-auto" style="max-width:375px;">
        <el-button type="primary" @click="onSubmit" class=" w-100">立即提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import AuthorService from '../../service/AuthorService.js'
export default {
  data () {
    return {
      form_list: null
    }
  },
  methods: {
    goApply () {
      this.$router.push({name: 'author_apply'})
    },
    onSubmit () {
      AuthorService.addForm(this.form_list).then(res => {
        this.$alert('申请成功', '申请成功', {
          confirmButtonText: '确定',
          callback: action => {
            this.init()
          }
        });
      })
    },
    init () {
      AuthorService.getForm({form_id: 1}).then(res => {
        this.form_list = res.data
      })
    }
  },
  mounted () {
    this.init()
  }
}
</script>
<style lang="scss" scoped>
.author-wrapper{
  max-width: 750px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
  :deep(.checkbox .el-form-item__content){
    line-height: 30px;
  }
  :deep(.el-form-item__label){
    line-height: 1.5;
  }
  :deep(.el-form-item){
    margin-bottom: 15px;
  }
}
</style>